import { useState, useEffect } from "react";
import { supabase } from "../../../../supabaseClient";
import { getTournamentSignups } from "../../../../utility/signupRpc";

export const useSignupData = (tournamentId) => {
  const [signups, setSignups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchSignups = async ({ silent = false } = {}) => {
    try {
      if (!silent) {
        setLoading(true);
      }
      setError(null);

      const data = await getTournamentSignups({ tournamentId });
      const rows = data?.signups || [];
      const ids = rows.map((row) => row.id).filter(Boolean);
      let requested = new Set();
      if (ids.length) {
        const { data: requests } = await supabase
          .from("signupRefundRequests")
          .select("signupID")
          .eq("status", "open")
          .in("signupID", ids);
        requested = new Set((requests || []).map((row) => row.signupID));
      }
      setSignups(
        rows.map((row) => ({
          ...row,
          refundRequested: Boolean(row.refundRequested) || requested.has(row.id),
        }))
      );
    } catch (error) {
      console.error("Error fetching signups:", error);
      setError(error.message || "Failed to load signups. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const refreshSignups = (options = {}) => fetchSignups(options);

  useEffect(() => {
    if (tournamentId) {
      fetchSignups();
    }
  }, [tournamentId]);

  return {
    signups,
    loading,
    error,
    refreshSignups,
  };
};
